import React from 'react';
import { Sidebar as SidebarV1 } from './v1/Sidebar';
import { Sidebar as SidebarV2 } from './v2/Sidebar';

export const Sidebar: React.FC<React.PropsWithChildren<{ sidebar; version?: 'v1' | 'v2' }>> = ({
  version = 'v1',
  ...props
}) => {
  if (version === 'v1') {
    return <SidebarV1 {...props} />;
  }
  return <SidebarV2 {...props} />;
};
